import { Component } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { fb } from '../../../../../shared/shared.global-service';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { InputText } from '@openng/optimus-ui/inputtext';
import { DeleteButtonComponent } from '../../../../../../components/kit/button/delete-button.component';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';

@Component({
    selector: 'app-service-settings-shifts-dialog',
    templateUrl: 'service-settings-shifts-dialog.component.html',
    imports: [
        ReactiveFormsModule,
        InputText,
        DeleteButtonComponent,
        ButtonComponent,
    ],
})
export class ServiceSettingsShiftsDialogComponent extends BaseDialogComponent {

    protected title = 'service.location.add.title';
    form: FormGroup;
    shiftsArray: FormArray;

    constructor() {
        super();
        this.shiftsArray = this.dialogConfig.data.shifts;
        this.form = fb.group({
            shifts: this.shiftsArray,
        });
    }

    addShift() {
        const control = fb.control('', [Validators.required, Validators.minLength(1)]);
        this.shiftsArray.push(control);
    }

    removeShift(index: number) {
        this.shiftsArray.removeAt(index);
    }

    override save(event: Event): void {
        if (isInvalid(this.form)) {
            return;
        }
        this.dialogRef.close(this.shiftsArray.value);
    }
}
